import * as React from 'react';
import { useState } from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { ApplicationState } from '../store';

import $ from 'jquery'

//icons
//  see https://react-icons.github.io/react-icons/icons?name=md
import { MdClose } from "react-icons/md";
import { SelectedRecProps } from './SurveyDefinitions';

var _props: SelectedRecProps;

export interface TicketRecipientRec {
	excludeFlag: boolean,
	createDate: Date,
	id: number,     //ticket #
	repetition: number,
	surveyName: string,
	surveyDefinitionID: string,
	emailAddress: string,
    outcome: string,
	pattern: string,
	portalName: string,
	reason: string,
	ruleName: string,
	serialNum: string,
	subject: string,
}



var _props: SelectedRecProps;
//close button handler
const closeSurveyHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    console.log('close TicketRecipientResults button clicked');
    //alert('close survey button clicked');
    _props.refreshList('close TicketRecipientResults button clicked');
  };

export function TicketRecipientResults(props: SelectedRecProps) {
    _props = props;
    
    if (props.mode == 'hidden') {
        //SurveyDefinition component is hidden
        return (
            <div></div>
        )
    }
    var baseUrl = process.env.REACT_APP_SURVEY_FUNCTIONCODE_GETTICKETRECIPIENTRESULTS;
    var url = buildUrlReplace(baseUrl, "{id}", _props.id);
    var ar: any = GetJsonResult(url);  //an array of objects

    //handle when the schedules is closed
    const refreshList = ():void => {
        alert('TicketRecipientResults.refreshList() called');
    }

    //shows the list of items
    return (
        <div className='width100pct'>
            <table width='100%'>
                <tbody>
                    <tr>
                        <td className='leftAlign' >Ticket Recipient Results</td>
                        <td className='rightAlign'><button onClick={closeSurveyHandler}><MdClose/></button></td>
                    </tr>
                </tbody>
            </table>
            
            
            <table className='table table-striped' aria-labelledby="tabelLabel">
            <thead>
                <tr>
                <th>Survey</th>
                <th>Ticket #</th>
                <th>Ticket Subject</th>
                <th>Recipient</th>
                <th>Allow/Excluded?</th>
                <th>Reason</th>
                <th>Rule</th>
                <th>Date</th>
                </tr>
            </thead>
            <tbody>
            {ar.map((rec: TicketRecipientRec) =>
                <tr key={rec.id}>
                <td>{rec.surveyName}</td>
                <td>{rec.id}</td>
                <td>{rec.subject}</td>
                <td>{rec.emailAddress}</td>
                <td>{rec.outcome}</td>
                <td>{rec.reason}</td>
                <td>{rec.ruleName}</td>
                <td>{new Intl.DateTimeFormat('en-US').format(new Date(rec.createDate))}</td>
                </tr>
            )}
            </tbody>
            </table>
            <hr></hr>
        </div>
    );
}

function GetJsonResult(url: any) {
    //NOTE: this should return an array of objects
    var result;
    $.ajax({
        method: "GET",
        async: false,
        url: url,
        dataType: "json"
    })
        .done(function (msg) {
            result = msg;
            return result;
        });

    return result;
}

function buildUrlReplace(url: any, searchFor: any, replaceWith: any) {
    var s = url;
    s = s.replace(searchFor, replaceWith)
    return s;
}



export default connect()(TicketRecipientResults);
